
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donor-portal",
      function () {
        return require("private-next-pages/donor-portal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donor-portal"])
      });
    }
  